export const exerciseOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "7b955cd4afmsh69f4e5c1865ba0bp1cb655jsn7695f94b91eb",
    "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
  },
};
export const youtubeOptions = {
  method: "GET",

  headers: {
    "X-RapidAPI-Key": "7b955cd4afmsh69f4e5c1865ba0bp1cb655jsn7695f94b91eb",
    "X-RapidAPI-Host": "youtube-search-and-download.p.rapidapi.com",
  },
};

export const fetchData = async (url, options) => {
  const response = await fetch(url, options);
  const data = await response.json();

  return data;
};
